import type { GroupTypeKey } from '@/shared/types/group';
import { Icon } from '@iconify/react';
import {
  Dropdown,
  DropdownTrigger,
  Button,
  DropdownMenu,
  DropdownItem,
} from '@/components/ui';
import { getGroupAlias } from './utils';
import { getMinistryStructure } from '@/store/org/types';
import type { MinistryTypeKey } from '@/shared/types/ministry';

export function CreateDropdown({
  onClick,
  ministry,
  triggerClassName,
}: {
  onClick: (type: GroupTypeKey, ministry: MinistryTypeKey) => void;
  ministry: MinistryTypeKey | '';
  triggerClassName?: string;
}) {
  if (!ministry) {
    return undefined;
  }

  const structure = getMinistryStructure(ministry);
  if (!structure) {
    return undefined;
  }

  const types = structure.map((item) => item.type);

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button
          color='primary'
          variant='solid'
          className={`flex flex-row items-center ${triggerClassName || ''}`}
        >
          Create <Icon icon='mdi:add' width='24' height='24' className='pl-2' />
        </Button>
      </DropdownTrigger>
      <DropdownMenu aria-label='Create Lay Group Options'>
        {types.map((type) => (
          <DropdownItem key={type} onPress={() => onClick(type, ministry)}>
            {getGroupAlias(type, 'type')}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
